import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Sitemap extends Component {
  render() {
    return (

      <div className="homepage-wrap">
        <div className="homepage">
          <h1>Layouts</h1>

          <ul style={{ padding:'0 20px' }}>
            <li>
              <p>authorization:</p>
              <ul>
                <li>
                  <Link to="/signup">sign up</Link>
                  <ul>
                    <li><Link to="/registration-step-1">step 1 - personal info</Link></li>
                    <li><Link to="/registration-step-2">step 2 - phone number</Link></li>
                    <li><Link to="/registration-step-3">step 3 - verifiction sms</Link></li>
                  </ul>
                </li>
                <li><Link to="/login">log in</Link></li>
                <li><Link to="/reset-password">reset password</Link></li>
              </ul>
            </li>

            <li>
              <p>sign in:</p>

              <ul>
                <li>
                  <Link to="/dashboard">dashboard (+ notification)</Link>
                  <ul>
                    <li><Link to="/dashboard/no-results">no results</Link></li>
                    <li style={{display:'none'}}><Link to="/dashboard/notification">notification</Link></li>
                  </ul>
                </li>
                <li>
                  <Link to="/booking">booking</Link>
                  <ul>
                    <li><Link to="/booking/kids-safety">kids safety</Link></li>
                    <li><Link to="/booking/flight">flight selection</Link></li>
                    <li><Link to="/booking/map">map</Link></li>
                    <li><Link to="/booking/summary">summary</Link></li>
                    <li><Link to="/booking/confirmed">confirmed</Link></li>
                  </ul>
                </li>
                <li>
                  <Link to="/account">my account</Link>

                  <ul>
                    <li><Link to="/account/profile">profile</Link></li>
                    <li><Link to="/account/cards">my cards</Link></li>
                    <li><Link to="/account/places">my places</Link></li>
                    <li><Link to="/account/invoices">invoices</Link></li>
                    <li><Link to="/account/settings">settings</Link></li>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <p>other subpages:</p>

              <ul>
                <li><Link to="/index">homepage</Link></li>
                <li><Link to="/how-it-works">how it works?</Link></li>
                <li><Link to="/pricing">pricing</Link></li>
                <li><Link to="/faq">faq</Link></li>
                <li><Link to="/contact">contact</Link></li>
                <li><Link to="/terms-and-conditions">terms of use</Link></li>
                <li><Link to="/privacy policy">privacy policy</Link></li>
                <li className="disabled"><Link to="/not-found">404 page</Link></li>
              </ul>
            </li>
          </ul>

        </div>
      </div>

    );
  }
}

export default Sitemap;
